import { z } from "zod";

interface IParseSchemaOption<T> {
  schema: z.ZodType<T>;
  rawData: unknown;
  onError?: (error: z.ZodError) => void;
}

export const parseSchema = <SchemaT>({ schema, rawData, onError }: IParseSchemaOption<SchemaT>): SchemaT | null => {
  const { success, data, error } = schema.safeParse(rawData);

  if (error) {
    // 커스텀 에러 처리
    if (typeof onError === "function") {
      onError(error);
    }

    // 공통 에러 처리
    // TODO. Error 공통 처리 함수 호출
    console.error("== zod parse error ==", error);
  }

  return success ? data : null;
};
